import { BaseContainerModel } from '../../base-container.model';
import {
  bl_dgmkt_campaign_schedule_link_RowClass,
  bl_dgmkt_campaign_schedule_link_RowInterface,
} from '../../../dbschema/bl_dgmkt_campaign_schedule_link.model';

export class DgMktCampaignScheduleContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_schedule_link: bl_dgmkt_campaign_schedule_link_RowInterface =
    new bl_dgmkt_campaign_schedule_link_RowClass();
}
